import React from 'react';
// Components
import ContactForm from '../forms/ContactForm';
import ContactBlurbSection from './ContactBlurbSection';

function ContactPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full'>
      <section className='grid w-full'>
        <div className='grid lg:grid-cols-2 gap-y-8 px-6 sm:px-8 lg:container lg:mx-auto md:px-10 py-8 gap-x-12'>
          {/* LEFT: Intro + contact info */}
          <ContactBlurbSection />

          {/* RIGHT: Form card (unchanged) */}
          <section className='grid' aria-labelledby='contact-form-title'>
            <h3 id='contact-form-title' className='sr-only'>
              Contact form
            </h3>
            <div className='grid bg-colour1 p-6 lg:p-8 rounded-2xl shadow-cardShadowBold'>
              <ContactForm />
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}

export default ContactPageMainContainer;
